import React from "react";
import { Outlet } from "react-router-dom";

import SectionMenu from "../../components/SectionMenu.jsx";

import "./PropertyLayout.css";

export default function PropertyLayout() {
  return (
    <div className="property-layout">
      <main className="property-content">
        <Outlet />
      </main>

      <SectionMenu />
    </div>
  );

  // return (
  //   <div
  //     style={{
  //       minHeight: "100vh",
  //       padding: "20px",
  //       background: "#eee",
  //     }}
  //   >
  //     <h1>PropertyLayout 正常</h1>

  //     <Outlet />
  //   </div>
  // );
}
